import React from 'react';
import Blog3 from '../../containers/BlogContainers/Blog3';
import PageHeader from '../Shared/PageHeader';

const BlogGrid = () => {
    return (
        <div>
            <PageHeader title="Blog Grid"></PageHeader>
            <Blog3></Blog3>

        </div>
    );
};

export default BlogGrid;